import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-77dccb4f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-list"
};
const _hoisted_2 = {
  key: 0,
  class: "empty-list"
};
import OrderCard from './OrderCard.vue';
import { ref, inject } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderList',
  props: {
    dataList: null
  },
  setup(__props) {
    const props = __props;
    const reloadList = inject('reloadList');
    const loading = ref(false);
    const onRefresh = async () => {
      await (reloadList === null || reloadList === void 0 ? void 0 : reloadList(true));
      loading.value = false;
    };
    return (_ctx, _cache) => {
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
        class: "order-list-refresh",
        modelValue: loading.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => loading.value = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataList, data => {
          return _openBlock(), _createBlock(OrderCard, {
            key: data.orderNo,
            data: data
          }, null, 8, ["data"]);
        }), 128)), !props.dataList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, " - 无订单 - ")) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});